import { Component } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Email } from 'components/icons';
import TellAFriend from 'components/productdetail/sharing/TellAFriend';
import { openPopup } from 'helpers';

import css from 'styles/components/productdetail/emailShare.scss';

export default class EmailShare extends Component {
  state = { isModalOpen: false };

  componentDidMount() {
    if (this.props.shouldOpenTellAFriendModal) {
      this.setState({ isModalOpen: true });
    }
  }

  onModalClose = () => {
    this.setState({ isModalOpen: false });
  };

  openModal = e => {
    e.preventDefault();
    this.setState({ isModalOpen: true });
  };

  render() {
    const { product, productId, colorId, firstName, marketplace } = this.props;
    const lineBreak = '%0D%0A';
    const { tellAFriendAction, useTellAFriendModal } = marketplace.pdp;
    const marketplaceName = marketplace.name[0].toUpperCase() + marketplace.name.slice(1);
    const signature = firstName ? `${lineBreak}${firstName}` : '';
    const subject = `I saw this on ${marketplaceName}`;
    const body = `Hey! I was shopping on ${marketplaceName} and stumbled across this:${lineBreak}${product.name} ${product.link}${lineBreak}Thoughts?${signature}`;
    const emailLink = `mailto:?subject=${subject}&body=${body}`;
    const { testId } = this.context;

    return (
      <span>
        <a
          href={`${tellAFriendAction}?productId=${productId}${colorId ? `&colorId=${colorId}` : ''}`}
          className={cn(css.desktop, css.email, { [css.hidden]: !tellAFriendAction })}
          onClick={useTellAFriendModal ? this.openModal : openPopup}
          data-popup-options="width=463,height=475"
          data-te="TE_PDP_SHARETELLAFRIEND"
          data-test-id={testId('tellAFriendShareIcon')}>
          <Email size={22} aria-label="Share by email"/>
        </a>
        {useTellAFriendModal && <TellAFriend
          isOpen={this.state.isModalOpen}
          onClose={this.onModalClose}
          productId={productId}
          colorId={colorId}/>}
        <a
          href={emailLink}
          className={cn(css.mobile, css.email, { [css.visible]: !tellAFriendAction })}
          onClick={useTellAFriendModal ? this.openModal : null}
          data-te="TE_PDP_SHAREEMAIL"
          data-test-id={testId('tellAFriendMobileShareIcon')}>
          <Email size={22}/>
        </a>
      </span>
    );
  }
}

EmailShare.contextTypes = {
  testId: PropTypes.func.isRequired
};
